import Offer from './Offer'
import OfferFilters from './OfferFilters'

const classes = [
  Offer,
  OfferFilters,
]

export default {
  offer: (...args) => new Offer(...args),
  offerFilters: (...args) => new OfferFilters(...args),
  clear: () => classes.forEach((c) => c.clear()),
}
